import { SelectedProvider, convertPublicProfileToSelectedProviderType } from '@uplift/pages';
import { Modal, NavigationBackButton, ProviderDialogNavigation, ScrollableView } from '@uplift/ui-v2';
import { useProfileContext } from '../profile.context';
import { useStates } from '@uplift/queries';
import { Box } from '@mui/material';
import { useIsMobile, useL10n } from '@uplift/hooks';

export type PreviewProfileModalProps = {
  open: boolean;
  onClose: () => void;
};

export const PreviewProfileModal: React.VFC<PreviewProfileModalProps> = props => {
  const { states } = useStates();
  const { profile } = useProfileContext();
  const isMobile = useIsMobile();
  const l10n = useL10n();

  const provider = convertPublicProfileToSelectedProviderType(profile, states);

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      fullScreen
    >
      <ProviderDialogNavigation
        position="sticky"
        title="Profile Preview"
        leftActions={
          <NavigationBackButton onClick={props.onClose}>{isMobile ? `${l10n.navigation.back}` : `${l10n.navigation.backToEdit}`}</NavigationBackButton>
        }
      />
      <ScrollableView>
        <Box>
          <SelectedProvider
            // use first license state for preview
            stateId={profile.licenses?.[0]?.stateId}
            selectedProvider={provider}
            onScheduleSession={() => {
              return;
            }}
            isPublicProfile
            isPreview
            isScrollableView
          />
        </Box>
      </ScrollableView>
    </Modal>
  );
};
